import { isEmpty } from 'lodash';
import { isNil } from 'ramda';
import type {
  AppStatus_Realworks_FullExcludingKenmerkenSync__KenmerkMapping,
  AppStatus_Realworks_FullSync__KenmerkMapping,
  AppStatus_Realworks_LimitToKenmerkenSync__KenmerkMapping,
  RealworksKenmerk,
} from '~/graphql/types';

type Params = {
  kenmerkMapping:
    | Array<
        | AppStatus_Realworks_FullSync__KenmerkMapping
        | AppStatus_Realworks_LimitToKenmerkenSync__KenmerkMapping
        | AppStatus_Realworks_FullExcludingKenmerkenSync__KenmerkMapping
      >
    | undefined
    | null;
  realworksKenmerken: Array<RealworksKenmerk>;
};

/**
 * Returns realworksKenmerkIds present in live Realworks kenmerken but absent from
 * the saved kenmerkMapping. Returns an empty array when there is no saved mapping
 * yet (initial setup), so CTA/highlight/pulse stay off until at least one mapping exists.
 */
const getMissingKenmerkIds = ({
  kenmerkMapping,
  realworksKenmerken,
}: Params): Array<number> => {
  if (isNil(kenmerkMapping) || isEmpty(kenmerkMapping)) return [];

  const savedIds = new Set(
    kenmerkMapping.map(({ realworksKenmerkId }) => realworksKenmerkId),
  );

  return realworksKenmerken
    .map(({ realworksKenmerkId }) => realworksKenmerkId)
    .filter(id => !savedIds.has(id));
};

export default getMissingKenmerkIds;
